import React from 'react';
import AppIcon from './AppIcon';
import Icon from './Icon';
import './ui.css';

/**
 * Vertical grid tile used in My Apps / Category / Store. Shows a lock or
 * coming-soon hint based on `state` ('open' | 'request' | 'coming-soon').
 */
export default function AppTile({ app, state = 'open', onClick }) {
  const locked = state !== 'open';
  return (
    <button
      type="button"
      className={`hive-apptile hive-tap hive-focusable${locked ? ' hive-apptile-locked' : ''}`}
      onClick={onClick}
    >
      <div className="hive-apptile-iconwrap">
        <AppIcon app={app} size={60} />
        {state === 'request' && (
          <span className="hive-apptile-lock">
            <Icon name="Lock" size={12} color="#fff" strokeWidth={2.4} />
          </span>
        )}
      </div>
      <span className="hive-apptile-name">{app.name}</span>
      <span className="hive-apptile-hint">
        {state === 'coming-soon' ? 'Coming soon' : state === 'request' ? 'Locked' : app.tagline}
      </span>
    </button>
  );
}
